import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  repo: z.string().min(1), // full_name e.g. "owner/repo"
  path: z.string().optional(),
  branch: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type GithubContentItem = {
  name: string;
  path: string;
  sha: string;
  size: number;
  type: 'file' | 'dir' | 'submodule' | 'symlink';
};

export type OutputType = {
  contents: GithubContentItem[];
};

export const getGithubContents = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams();
  params.set('repo', input.repo);
  if (input.path) params.set('path', input.path);
  if (input.branch) params.set('branch', input.branch);

  const result = await fetch(`/_api/github/contents?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
